import { configureStore } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import appReducer from '../AppSlice';
import calendarReducer from '../features/pages/CalendarSlice';

export default configureStore({
  reducer: {
    counter: counterReducer,
    app: appReducer,
    calendar: calendarReducer,
  },
});
